import { Breakpoints, styled } from '@vw-marketing/us-components';

export const StyledNicknameFormWrapper: any = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.static350};
  width: 100%;
  margin-top: ${({ theme }) => theme.size.static350};

  @media (min-width: ${Breakpoints.b560}px) {
    margin-top: ${(props) => props.theme.size.static400};
  }

  // Hide the red icon in the input when the status is error
  & [class^='StyledLayerScrollContainer-'],
  & [class*='StyledLayerScrollContainer-'] {
    svg {
      display: none !important;
    }
  }

  & [class^='StyledLabel-'],
  & [class*='StyledLabel-'] {
    margin-bottom: ${({ theme }) => theme.size.static350};
  }
`;
